import { render, staticRenderFns } from "./VehicleDetails.vue?vue&type=template&id=42081556&scoped=true&"
import script from "./VehicleDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleDetails.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDetails.vue?vue&type=style&index=0&id=42081556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42081556",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VTab,VTabItem,VTabs,VTabsItems})
